<template>
  <el-form
    :model="form"
    :rules="rule"
    ref="form"
    :label-position="labelPosition"
    label-width="100px"
    class="qr-code-form"
  >
    <el-form-item label="二维码类型" prop="isTemp">
      <el-radio v-model="form.isTemp" :label="true">临时</el-radio>
      <el-radio v-model="form.isTemp" :label="false">永久</el-radio>
    </el-form-item>
    <el-form-item label="场景ID" prop="sceneId">
      <el-input v-model="form.sceneId" placeholder="任意字符串" maxlength="64"></el-input>
    </el-form-item>
    <el-form-item label="场景值" prop="sceneStr">
      <el-input v-model="form.sceneStr" placeholder="任意字符串" maxlength="64"></el-input>
    </el-form-item>
    <el-form-item label="失效时间/秒" prop="expireSeconds" v-if="form.isTemp">
      <el-input v-model="form.expireSeconds" placeholder="单位：秒，最大2592000（30天）"></el-input>
      <div>最大30天，当前设置：<span class="theme-color">{{form.expireSeconds/(24*3600)}}天</span></div>
    </el-form-item>
    <div class="out-box">
      <a class="theme-color a-tips" v-show="!form.isTemp" target="_blank" href="https://developers.weixin.qq.com/doc/offiaccount/Account_Management/Generating_a_Parametric_QR_Code.html">注意永久二维码上限10万个，且暂时无法删除旧的二维码</a>
    </div>
  </el-form>
</template>

<script>
let origin = {
  isTemp: true,
  sceneId: '',
  sceneStr: '',
  expireSeconds: 2592000
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "qrcodeForm",
  data() {
    return {
      form: JSON.parse(JSON.stringify(origin)),
      rule: {
        isTemp: [
          { required: true, message: '二维码类型不能为空', trigger: 'blur' }
        ],
        sceneId: [
          { required: true, message: '场景ID不能为空', trigger: 'blur' }
        ],
        sceneStr: [
          { required: true, message: '场景值不能为空', trigger: 'blur' }
        ],
        expireSeconds: [
          { required: true, message: '该二维码失效时间不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mixins: [formLabalPosition],
  methods: {
    selfValidate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form);
        }
      })
    },
    selfClear() {
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.qr-code-form {
  .out-box {
    margin-left: 100px;
  }
  .a-tips {
    text-decoration: underline;
    color: $themeColor;
  }
}
</style>
